"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockDateObject = exports.mockDateTime = void 0;
exports.mockDateTime = new Date().toLocaleString();
exports.mockDateObject = {
    created_at: exports.mockDateTime,
    updated_at: exports.mockDateTime,
    deleted_at: null,
};
